import React from 'react';
import { DNABox, DNAText } from '@alucio/lux-ui';
import { useSlideRollState } from '../SlideRollProvider';
import { SLIDE_ROLL_VARIANT } from '../StyleSetting';

const EmptyState: React.FC = () => {
  const { variant } = useSlideRollState();

  if (variant !== SLIDE_ROLL_VARIANT.PREVIEW_MODAL_EMPTY) return null;
  return (
    <DNABox>
      <DNAText status="subtle">No presented slides</DNAText>
    </DNABox>
  )
};

export default EmptyState;
